const GET_BILL_AZURE = 'GET_BILL_AZURE';
const GET_BILL_AZURE_SUCCESS = 'GET_AZURE_BILL_SUCCESS';
const GET_BILL_AZURE_ERROR = 'GET_AZURE_BILL_ERROR';
 
export {
  GET_BILL_AZURE, GET_BILL_AZURE_SUCCESS, GET_BILL_AZURE_ERROR
  
};
